import React, { useState } from 'react'
import { WebTagContext } from '../../context/WebTagContext'
import { WebTagWizard } from '../web-tag-wizard/WebTagWizard'

export const WebTagApp = () => {

    const [step, setStep] = useState( {
        current: 1
    } );

    const [loading, setLoading] = useState({
        document_types: false,
        car_brands: false,
        car_models: false,
        car_colors: false,
        add_tag_request: false
    });

    const [error, setError] = useState('');

    const [userData, setUserData] = useState( {
        documentType: '',
        document: '',
        name1: '',
        name2: '',
        lastName1: '',
        lastName2: '',
        dob: '',
        sex: '',
        phone: '',
        cellphone: '',
        email: ''
    } );

    const [tagCar, setTagCar] = useState( {
        tag: '',
        carRegistration: '',
        brand: '',
        brandModel: '',
        color: '',
        carYear: ''
    } );

    const [transaction, setTransaction] = useState({
        code: 0
    });
    
    return (
        <WebTagContext.Provider value = { {
            step,
            userData,
            tagCar,
            error,
            loading,
            transaction,
            setStep,
            setUserData,
            setTagCar,
            setError,
            setLoading,
            setTransaction
        } }>
            <WebTagWizard />
        </WebTagContext.Provider>
    );
}
